/**
 * 找样任务池
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/25      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React,{useState} from 'react'
import PropTypes from "prop-types";
import {Tabs,Form,Input,Button,Empty,Pagination,Spin} from 'antd';
import Lang from "@components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import qs from 'query-string';
import request from "../../../../utils/request";
import Item from "./components/Item";
import PageCommon from  "@components/PageCommon/PageCommon";
import "./index.less";
class Page extends React.Component{
    constructor(props) {
        super(props);
        const data = qs.parse(this.props.location.search)||{};
        this.state = {
            tabType: data.tabType||11,
            buyerCode:'',
            id:'',
            recommendUserName:'',
            list:[],
            loading:false,
            pagingQuery: {
                pageSize: 60,
                pageIndex: 1,
                total:0
            },
        }
        this.query = {};
        this.time = null;
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;

    onChangeTab(key){
        this.setState({
            tabType: key,
        },() => {
            this.getData(1);
        })
    }

    changeInput(name,e){
        this.setState({
            [name]:e.target.value
        })
    }

    search(){
        this.query = {
            buyerCode:this.state.buyerCode,
            recommendUserName:this.state.recommendUserName,
            id:this.state.id
        }
        this.getData(1);
    }

    onChangePage = (page, pageSize) => {
        this.setState({
            pagingQuery: {
                pageSize: pageSize,
                pageIndex: page
            }
        }, () => {
            this.getData();
        })
    }

    getData(pageIndex){
        this.setState({
            loading:true,
            list:[],
            extra:{}
        },()=>{
            let state = {
                loading:false
            }
            const time = new Date().getTime();
            this.time = time;
            request.post(
                "/service/mg/fuzzy/list",
                {
                    ...this.query,
                    tabType:this.state.tabType,
                    pagingQuery: {
                        pageIndex: pageIndex||this.state.pagingQuery.pageIndex,
                        pageSize: this.state.pagingQuery.pageSize,
                    },
                }
            )
                .then((response) => {
                    if(this.time!=time){
                        return false;
                    }
                    const res = response.data;
                    if(res.success&&res.valid){
                        state.list = res.models||[];
                        state.extra = res.extra||{};
                    }
                    //分页
                    if(res.paging){
                        state.pagingQuery = {
                            pageIndex:res.paging.pageNum,
                            pageSize: res.paging.pageSize,
                            total:res.paging.total
                        };
                    }else{
                        state.pagingQuery = {
                            pageIndex: 1,
                            pageSize: 60,
                            total:0
                        };
                    }
                    this.setState(state,()=>{
                        this.onRefPageCommonChild.isShowTop();
                    });
                },()=>{
                    this.setState(state);
                });
        })
    }

    componentDidMount() {
        this.getData(1);
    }

    render(){
        const {list = [],pagingQuery={},extra={},tabType} = this.state;
        return (
            <PageCommon onRef={this.onRefPageCommon} showTop={true}>
                <CommonBreadcrumb list={[
                    {name:Lang({id:"ZhaoYangRenWu", default:"找样任务"})},
                ]}></CommonBreadcrumb>
                <div>
                    <div className="font_24 color089 mb_16">{Lang({id:'ZhaoYangRenWuChi',default:'找样任务池'})}</div>
                    <div>
                        <Tabs activeKey={tabType} onChange={this.onChangeTab.bind(this)}
                              items={[
                                  {
                                      key: '11',
                                      label: <div>
                                          {<Lang id="DaiGenJin">待跟进</Lang>}
                                          {
                                              extra.waitFollowCount?
                                                  <span className="ml_8">{extra.waitFollowCount}</span>
                                                  :
                                                  null
                                          }
                                      </div>,
                                  },
                                  {
                                      key: '12',
                                      label: <div>
                                          {<Lang id="BieRenGenJin">别人跟进</Lang>}
                                      </div>,
                                  },
                                  {
                                      key: '13',
                                      label: <div>
                                          {<Lang id="WoDeGenJin">我的跟进</Lang>}
                                      </div>,
                                  }
                              ]}
                        >
                        </Tabs>
                    </div>
                    <Form className="search" layout="inline">
                        <Form.Item label={Lang({id: "KeHuBianHao", default: "客户编号"})}>
                            <Input placeholder={Lang({id: "QingShuRu", default: "请输入"})}
                                   onChange={this.changeInput.bind(this,'buyerCode')}/>
                        </Form.Item>
                        {
                            this.state.tabType =='12'?
                                <Form.Item label={Lang({id: "PinLeiJingLi", default: "品类经理"})}>
                                    <Input placeholder={Lang({id: "QingShuRu", default: "请输入"})}
                                           onChange={this.changeInput.bind(this,'recommendUserName')}/>
                                </Form.Item>:
                                null
                        }
                        <Form.Item label={Lang({id: "RenWuBianHao", default: "任务编号"})}>
                            <Input placeholder={Lang({id: "QingShuRu", default: "请输入"})}
                                   onChange={this.changeInput.bind(this,'id')}/>
                        </Form.Item>
                        <Button className="btn-little-blue" onClick={this.search.bind(this)}>
                            {Lang({id: "SouSuo", default: "搜索"})}
                        </Button>
                    </Form>
                    <Spin spinning={this.state.loading}>
                        <div>
                            <div className="fuzzy-task__wrap">
                                {
                                    list.map((item,index)=>{
                                        return <Item key={index} tabType={this.state.tabType} extra={extra} item={item}></Item>
                                    })
                                }
                            </div>
                            {
                                list.length==0?
                                    <Empty description={Lang({id: "ZanWuShuJu", default: "暂无数据"})} className="mt_40 mb_40"></Empty>
                                    :
                                    null
                            }
                        </div>
                        {/*分页*/}
                        {
                            pagingQuery.total>0?
                                <div className="mt_16 mb_16 text-center">
                                    <Pagination
                                        showSizeChanger={false}
                                        current={pagingQuery.pageIndex || 1}
                                        pageSize={pagingQuery.pageSize}
                                        total={pagingQuery.total || 0}
                                        onChange={this.onChangePage.bind(this)}/>
                                </div>
                                :
                                ''
                        }
                    </Spin>
                </div>
            </PageCommon>
        )
    }
}

Page.defaultProps = {
}

Page.propTypes = {

}
export default Page;
